import React from 'react';
import { StarIcon } from 'lucide-react';
import { Section } from './Shared';
export type TestimonialProps = {
  initials: string;
  name: string;
  location: string;
  product: string;
  text: string;
};
export function TestimonialCard({
  initials,
  name,
  location,
  product,
  text
}: TestimonialProps) {
  return <article className="glass-panel flex h-full flex-col rounded-2xl p-6 md:p-7" data-id="element-293" data-mp="3b1cjxalmx0j5">
      <div className="mb-4 flex items-center gap-3" data-id="element-294" data-mp="36zimdb6qkcn7">
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-brand-gold/55 bg-brand-surfaceLight font-serif font-bold text-brand-purple" data-id="element-295" data-mp="370al2uvmqqhp">{initials}</div>
        <div data-id="element-296" data-mp="2x11t27kbrlxz">
          <div className="flex text-brand-gold" aria-label="5 de 5 estrellas" data-id="element-297" data-mp="2x2w4mv9pi1pe">
            {Array.from({
            length: 5
          }, (_, index) => <StarIcon key={index} className="h-3.5 w-3.5 fill-current" aria-hidden="true" data-id="element-298" data-mp="v9gedzhj6ouy" />)}
          </div>
          <p className="mt-1 font-semibold text-brand-ink" data-id="element-299" data-mp="qallg4punjx4">{name}</p>
          <p className="text-xs text-brand-muted" data-id="element-300" data-mp="q89701javrot">{location} · {product}</p>
        </div>
      </div>
      <p className="font-serif text-base leading-relaxed text-brand-text" data-id="element-301" data-mp="h8aytf4m6trr">“{text}”</p>
    </article>;
}
export function InitialTestimonials() {
  return <Section className="pt-6" data-id="element-302" data-mp="78trkt9ps7to">
      <div className="mx-auto max-w-3xl" data-id="element-303" data-mp="79v6x9xrjgh7">
        <TestimonialCard initials="MG" name="María G." location="Córdoba" product="Terapeuta Reiki" text="Por primera vez tengo una estructura clara para cada sesión. Mis pacientes sienten la diferencia desde el primer encuentro. La confianza que transmite trabajar con método es inmediata." data-id="element-304" data-mp="c6bv244ypuua" />
      </div>
    </Section>;
}
export function MoreTestimonials() {
  const testimonials: TestimonialProps[] = [{
    initials: 'MG',
    name: 'María G.',
    location: 'Córdoba',
    product: 'Terapeuta Reiki',
    text: 'Por primera vez tengo una herramienta que puedo abrir antes de cada sesión y saber exactamente qué voy a trabajar y por qué. La seguridad que transmite trabajar con sistema es total. Mis pacientes lo notan desde el primer encuentro.'
  }, {
    initials: 'JL',
    name: 'Julián L.',
    location: 'Buenos Aires',
    product: 'Terapeuta holístico',
    text: 'El nivel de detalle del Tomo 2 es impresionante. Tengo 20 protocolos listos para usar según el motivo de consulta. Nunca más llegué a una sesión sin saber exactamente qué hacer. No existe nada igual en español.'
  }, {
    initials: 'SM',
    name: 'Sofía M.',
    location: 'Rosario',
    product: 'Terapeuta Reiki en formación',
    text: 'Recién empezaba y el MEGA PACK me dio la estructura y la seguridad que necesitaba desde el primer paciente. El Reloj Maestro™ y el Ritual de los 15 Minutos™ solos valen todo el pack.'
  }, {
    initials: 'DL',
    name: 'Diego L.',
    location: 'Tucumán',
    product: 'Practicante holístico',
    text: 'El Bono de Fichas Profesionales transformó mi relación con cada paciente. Ahora tengo continuidad real en cada proceso. Mis sesiones tienen una profundidad completamente diferente a la de antes.'
  }];
  return <Section data-id="element-305" data-mp="32gw6un1pqqg4">
      <div className="mb-10 text-center" data-id="element-306" data-mp="32h5w28exotkr"><h2 className="font-display text-3xl font-bold text-brand-ink md:text-4xl" data-id="element-307" data-mp="32g49p7sgwknq">LO QUE DICEN LOS TERAPEUTAS QUE YA LO TIENEN</h2></div>
      <div className="mx-auto grid max-w-4xl grid-cols-1 gap-6 md:grid-cols-2" data-id="element-308" data-mp="37i3bwech1bj3">
        {testimonials.map(testimonial => <TestimonialCard key={testimonial.initials} {...testimonial} data-id="element-309" data-mp="3ggorq1qk6cg6" />)}
      </div>
    </Section>;
}